// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__XeZQw","links":"Footer_links__1dlR4","link":"Footer_link__3yrmY","icons":"Footer_icons__378Y7","separator":"Footer_separator__-zyi8"};